// EXPERIMENT: psf_promote_or_share_qr_code_experiment — remove with experiment cleanup
import { useMemo } from 'react';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';

import { type QrPosterTracking, useGetShareTrackingData, useQrPosterTracking } from './share/tracking';

/**
 * What the `variant_2` poster view needs to build the Flyer A for this petition, and how it tracks
 * Print. Print's `psf_qr_poster_print` carries the same share tracking data as Save's, so both QR
 * shares stay comparable.
 */
export type QrCodePoster = Readonly<{
	petitionId: string;
	getTrackingData: () => Readonly<Record<string, boolean | string | number | undefined>>;
	trackPrinted: QrPosterTracking['trackPrinted'];
}>;

export function useQrCodePoster(): QrCodePoster {
	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePsfPromoteOrSharePageData();
	const getTrackingData = useGetShareTrackingData();
	const { trackPrinted } = useQrPosterTracking();

	return useMemo(() => ({ petitionId, getTrackingData, trackPrinted }), [petitionId, getTrackingData, trackPrinted]);
}
